/** Версия оформления фильтров; задаётся через `@Input()` на компонентах (не из URL). */
export type FiltersUiVersion = 'v1' | 'v2';

/** Класс на контейнере / host для глобальных стилей V2. */
export const FRM_FILTERS_UI_V2_HOST_CLASS = 'frm-filters-ui-v2';

/** Класс панели overlay (multiselect, datepicker) при `appendTo="body"`. */
export const FRM_FILTERS_UI_V2_PANEL_CLASS = 'frm-filters-ui-v2-panel';
